<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Eric Ashworth and Gloria Safier</span></p>
<p class="ded1"><span>Wish you were here</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?4f12d641